// Competitor Analysis Form functionality for new page
document.addEventListener('turbo:load', function() {
  // Calendar functionality - global functions for backward compatibility
  function applyDateRange() {
    const calendarElement = document.getElementById('range-cally-element');
    const value = calendarElement.value;
    if (value) {
      const [fromDate, toDate] = value.split('/');
      const url = new URL(window.location);
      url.searchParams.set('fromDate', fromDate);
      url.searchParams.set('toDate', toDate);
      window.location.href = url.toString();
    }
  }
  
  function closeCalendar() {
    document.querySelector('.dropdown-content').blur();
  }
  
  // Make functions globally available
  window.applyDateRange = applyDateRange;
  window.closeCalendar = closeCalendar;

  // Form functionality (for new page)
  const select = document.querySelector('select[multiple]');
  if (select) {
    // Add visual feedback for selection
    select.addEventListener('change', function() {
      const selectedCount = this.selectedOptions.length;
      const label = document.querySelector('.label-text-alt');
      if (label && selectedCount > 0) {
        label.textContent = `${selectedCount}件のアカウントが選択されています`;
        label.classList.add('text-primary');
      }
    });

    // Add keyboard navigation help
    select.addEventListener('focus', function() {
      const helpText = document.createElement('div');
      helpText.className = 'text-xs text-base-content/70 mt-2';
      helpText.id = 'select-help';
      helpText.innerHTML = '💡 Ctrl/Cmd + クリックで複数選択、Shift + クリックで範囲選択できます';
      
      if (!document.getElementById('select-help')) {
        select.parentNode.appendChild(helpText);
      }
    });
  }
});
